import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

import { Alert } from '../../../components/atoms'

import { LoadingView } from '../../../../common/components/atoms';
import { ERROR_MESSAGE } from '../../../common/constants.js';
import shadowPlusTaglineLogo from '../../../components/atoms/data/standard-tagline-color.svg';

class Login extends Component {
    constructor(props) {
        super(props);

        this.refAlert = React.createRef();
        this.state = {
            address: "",
            password: "",
            displayAlert: false,
            errorMessage: "",
        }
    }

    componentDidMount() {
        let token = localStorage.getItem('token');
        this.props.dispatch({
            type: "CheckMaintenance_Saga"
        });
        if(token && this.props.user) {
            this.props.dispatch({
                type: "LoadStart"
            });
            this.props.dispatch({
                type: 'LoginCheck_Saga',
                id: this.props.user.id,
                token: token,
                onSuccess: this.onSuccessLoginCheck,
                onFailure: this.onFailureLoginCheck,
            });
        } else {
            this.props.dispatch({
                type: "ClearUserInfo"
            });
            this.props.dispatch({
                type: "LoadEnd"
            });
        }
    }
    onSuccessLoginCheck = () => {
        this.props.dispatch({
            type: "LoadEnd"
        });
        this.props.history.push('/home');
    }
    onFailureLoginCheck = () => {
        this.props.dispatch({
            type: "LoadEnd"
        });
    }

    onSuccess = (user) => {
        this.props.dispatch({
            type: "LoadEnd"
        });
        if (user.tempPWFlg) {
            this.props.history.push('/settingpassword');
        } else {
            this.props.history.push('/home');
        }
    }
    onFailure = (status, error) => {
        this.props.dispatch({
            type: "LoadEnd"
        });
        if(status !== 400) {
            this.refAlert.current.setAlertAnime();
            if (status === 401) {
                // パスワード認証エラー
                this.setState({
                    displayAlert: true,
                    errorMessage: ERROR_MESSAGE["login_failure"],
                });
            } else if(status === 405) {
                // 退会済みエラー
                let errmessage = [];
                for (const msg of ERROR_MESSAGE["unsubscribe"]) {
                    errmessage.push(msg);
                    errmessage.push(<br />);
                }
                this.setState({
                    displayAlert: true,
                    errorMessage: errmessage,
                });
            } else {
                // 端末上限（トークン最大）エラー
                let errmessage = [];
                for (const msg of ERROR_MESSAGE["maximum_login"]) {
                    errmessage.push(msg);
                    errmessage.push(<br />);
                }
                
                this.setState({
                    displayAlert: true,
                    errorMessage: errmessage,
                });
            }
        }
    }

    onClickLogin = (e) => {
        this.props.dispatch({
            type: "LoadStart"
        });
        this.props.dispatch({
            type: 'Login_Saga',
            address: this.state.address,
            password: this.state.password,
            admin: false,
            onSuccess: this.onSuccess,
            onFailure: this.onFailure,
        });
    }

    onChange = (e) => {
        const { name, value } = e.target;
        this.setState({
            [name]: value
        })
    }

    render() {
        const propAlert = {
            display: this.state.displayAlert,
            message: this.state.errorMessage,
        }
        return (
            <Body>
                <img alt="shdplus-logo" src={shadowPlusTaglineLogo} style={{width: "150px"}} />
                <Input>
                    <input type="text" name="address" value={this.state.address} placeholder="メールアドレス"
                        onChange={this.onChange}></input>
                </Input>
                <Input>
                    <input type="password" name="password" value={this.state.password} placeholder="パスワード"
                        onChange={this.onChange}></input>
                </Input>
                <Link to={'/remind'}>パスワードを忘れましたか？</Link>
                <Alert ref={this.refAlert} {...propAlert} />
                <Button onClick={this.onClickLogin}>
                    ログイン
                </Button>
                <LoadingView Display={this.props.loading} />
            </Body>
        );
    }
}

const mapStateToProps = store => {
    return {
        loading: store.loading.loading ? store.loading.loading : false,
        user: store.login.user,
    }
};

const connectedLogin = connect(mapStateToProps)(Login);
export { connectedLogin as Login };

const Body = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    padding: 32px 0;
`;

const Logo = styled.img`
    width: 208px;
    height: 32px;
    margin-bottom: 32px;
`;
const Input = styled.div `
    width: 100%;
    max-width: 320px;
    text-align: center;
    margin: 20px 0;
    font-size: 20px;
    input {
        width: 80%;
        font-size: 20px;
        padding: 10px 20px;
    }
`;

const Button = styled.div`
    position: absolute;
    bottom: 32px;
    left: 50%;
    transform: translateX(-50%);
    font-size: 20px;
    padding: 10px 20px;
    background-color: #0077FF;
    color: #fff;
    border-radius: 50px;
    width: 80%;
    max-width: 258px;
    text-align: center;
    cursor: pointer;
`;
